module.exports = __webpack_public_path__ + "img/banner.2ac57f33.jpg";